import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { CloserLook } from './components/CloserLook';
import { Steps } from './components/Steps';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-0" data-mp="2rit335f91uqf">
      <Header data-id="element-1" data-mp="2mmvk0rclqa9y" />
      <main data-id="element-2" data-mp="2mndpmel5m0uj">
        <Hero data-id="element-3" data-mp="2mnnefyugq1yn" />
        <HowItWorks data-id="element-4" data-mp="2mjznn7gejtnm" />
        <Features data-id="element-5" data-mp="31agput0v2nlk" />
        <CloserLook data-id="element-6" data-mp="31ayvgg9eye65" />
        <Steps data-id="element-7" data-mp="31c9w477kb5t1" />
        <FAQ data-id="element-8" data-mp="31ctefp14jw7l" />
        <FinalCTA data-id="element-9" data-mp="31cjp83nwlt2y" />
      </main>
      <Footer data-id="element-10" data-mp="2wjgu3r3habkn" />
    </div>;
}